import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'numberSuffix' })
export class NumberSuffixPipe implements PipeTransform {
  private readonly suffixes = [
    { value: 1e24, symbol: 'Y' }, // yotta
    { value: 1e21, symbol: 'Z' }, // zetta
    { value: 1e18, symbol: 'E' }, // exa
    { value: 1e15, symbol: 'P' }, // peta
    { value: 1e12, symbol: 'T' }, // tera
    { value: 1e9, symbol: 'G' }, // giga
    { value: 1e6, symbol: 'M' }, // mega
    { value: 1e3, symbol: 'k' }, // kilo
    { value: 1, symbol: '' }, // base
    { value: 1e-3, symbol: 'm' }, // milli
    { value: 1e-6, symbol: 'µ' }, // micro
    { value: 1e-9, symbol: 'n' }, // nano
    { value: 1e-12, symbol: 'p' }, // pico
    { value: 1e-15, symbol: 'f' }, // femto
    { value: 1e-18, symbol: 'a' }, // atto
    { value: 1e-21, symbol: 'z' }, // zepto
    { value: 1e-24, symbol: 'y' }, // yocto
  ];

  transform(value: number, decimalPlaces: number = 0, unit: string | null = null): string {
    if (isNaN(value) || !isFinite(value)) return '';

    const absValue = Math.abs(value);
    const suffix = this.suffixes.find((s) => absValue >= s.value);

    if (Math.abs(value) < Number.EPSILON || !suffix) return unit ? `0 ${unit}` : '0';

    let scaled = (value / suffix.value).toFixed(decimalPlaces);
    // remove trailing zeros
    scaled = scaled.replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1');
    if (unit) {
      return `${scaled} ${suffix.symbol}${unit}`;
    } else {
      return `${scaled}${suffix.symbol}`;
    }
  }
}
